const WIZARD_CODES = {
  ONBOARDING: 'onboarding',
  PATIENT_CHECKIN: 'patient_checkin',
  INSTANT_PACKET: 'instant_packet',
  SELF_SCHEDULING: 'self_scheduling'
};

export default WIZARD_CODES;
